import { useContext, useEffect, useState } from "react";
import { serverInfo } from "../../App";

const LeftCardPhotos = (props) => {

  const { imageCdnUrl } = useContext(serverInfo);

  return (
    <>
      <div className="container left-col-box py-4">
        <h6 className="profile-font-color">{props.title}</h6>
        <div className="row">
          {props?.photos?.map(
            (data, index) =>
              <>
                {data?.type === "audition" &&
                  data?.audition?.banner != null ? (
                  <div className="col-4">
                    <img
                      src={imageCdnUrl + data?.audition?.banner}
                      alt=""
                      className="img-fluid profile-photos"
                    />{" "}
                  </div>
                ) : data?.type === "generalpost" &&
                  data?.generalpost?.image != null ? (
                  <div className="col-4">
                    <img
                      src={imageCdnUrl + data?.generalpost?.image}
                      alt=""
                      className="img-fluid profile-photos"
                    />{" "}
                  </div>
                ) : data?.type === "learningSession" &&
                  data?.learning_session?.banner != null ? (
                  <div className="col-4">
                    <img
                      src={imageCdnUrl + data?.learning_session?.banner}
                      alt=""
                      className="img-fluid profile-photos"
                    />{" "}
                  </div>
                ) : data?.type === "meetup" &&
                  data?.meetup?.banner != null ? (
                  <div className="col-4">
                    <img
                      src={imageCdnUrl + data?.meetup?.banner}
                      alt=""
                      className="img-fluid profile-photos"
                    />{" "}
                  </div>
                ) : data?.type === "liveChat" &&
                  data?.livechat?.banner != null ? (
                  <div className="col-4">
                    <img
                      src={imageCdnUrl + data?.livechat?.banner}
                      alt=""
                      className="img-fluid profile-photos"
                    />{" "}
                  </div>
                ) : data?.type === "qna" &&
                  data?.qna?.banner != null ? (
                  <div className="col-4">
                    <img
                      src={imageCdnUrl + data?.qna?.banner}
                      alt=""
                      className="img-fluid profile-photos"
                    />{" "}
                  </div>
                ) : data?.type === "marketplace" &&
                  data?.marketplace?.image != null ? (
                  <div className="col-4">
                    <img
                      src={imageCdnUrl + data?.marketplace?.image}
                      alt=""
                      className="img-fluid profile-photos"
                    />{" "}
                  </div>
                ) : data?.type === "auction" &&
                  data?.auction?.product_image != null ? (
                  <div className="col-4">
                    <img
                      src={imageCdnUrl + data?.auction?.product_image}
                      alt=""
                      className="img-fluid profile-photos"
                    />{" "}
                  </div>
                ) : data?.type === "souvenir" &&
                  data?.souvenir?.banner != null ? (
                  <div className="col-4">
                    <img
                      src={imageCdnUrl + data?.souvenir?.banner}
                      alt=""
                      className="img-fluid profile-photos"
                    />{" "}
                  </div>
                ) : data?.type === "fangroup" &&
                  data?.fangroup?.banner != null ? (
                  <div className="col-4">
                    <img
                      src={imageCdnUrl + data?.fangroup?.banner}
                      alt=""
                      className="img-fluid profile-photos"
                    />{" "}
                  </div>
                ) : data?.type === "greeting" && data?.greeting_registration?.video != null ? (
                  <div className="col-4">
                    <img
                      src={imageCdnUrl + data?.greeting_registration?.greeting?.banner}
                      alt=""
                      className="img-fluid profile-photos"
                    />{" "}
                  </div>
                ) : null}
              </>
          )}
        </div>
        <div className="see-all-text  mt-3">
          <a href="/" className="text-decoration-none profile-font-color ">
            See all
          </a>
        </div>
      </div>
    </>
  );
};

export default LeftCardPhotos;
